import axios from 'axios'
export default axios.create({
  timeout: 5000,
  headers: {
    'apikey': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
    'Content-Type': 'application/json'
  }
})